import { Action } from '@ngrx/store';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { SapInvoice, SapInvoiceFilter, SapInvoicesFromMW } from '../../interfaces/sap-invoice.interface';
import { ErrorMessage } from '../../util/error.interface';

export const CLEAR_SAP_INVOICES_FILTER = 'sap-invoice:CLEAR_SAP_INVOICES_FILTER';
export const QUERY_SAP_INVOICES_START = 'sap-invoice:QUERY_SAP_INVOICES_START';
export const QUERY_SAP_INVOICES_SUCCESS = 'sap-invoice:QUERY_SAP_INVOICES_SUCCESS';
export const QUERY_SAP_INVOICES_FAIL = 'sap-invoice:QUERY_SAP_INVOICES_FAIL';

export const SAP_INVOICE_DOWNLOAD = 'sap-invoice:SAP_INVOICE_DOWNLOAD';
export const SAP_INVOICE_DOWNLOAD_SUCCESS = 'sap-invoice:SAP_INVOICE_DOWNLOAD_SUCCESS';
export const SAP_INVOICE_DOWNLOAD_FAIL = 'sap-invoice:SAP_INVOICE_DOWNLOAD_FAIL';

export const SAP_INVOICE_DOWNLOAD_LIST = 'sap-invoice:SAP_INVOICE_DOWNLOAD_LIST';
export const SAP_INVOICE_DOWNLOAD_LIST_SUCCESS = 'sap-invoice:SAP_INVOICE_DOWNLOAD_LIST_SUCCESS';
export const SAP_INVOICE_DOWNLOAD_LIST_FAIL = 'sap-invoice:SAP_INVOICE_DOWNLOAD_LIST_FAIL';

export const GET_VALUTA_FOR_CUSTOMERS = 'sap-invoice:GET_VALUTA_FOR_CUSTOMERS';
export const GET_VALUTA_FOR_CUSTOMERS_SUCCESS = 'sap-invoice:GET_VALUTA_FOR_CUSTOMERS_SUCCESS';
export const GET_VALUTA_FOR_CUSTOMERS_FAIL = 'sap-invoice:GET_VALUTA_FOR_CUSTOMERS_FAIL';
export const SET_DEFAULT_VALUTA = 'sap-invoice:SET_DEFAULT_VALUTA';

export interface BlobAction extends Action {
  readonly payload: { blob: Blob; filename: string };
}

export class ClearSapInvoicesFilterAction implements Action {
  readonly type = CLEAR_SAP_INVOICES_FILTER;
}

export class QuerySapInvoicesStartAction implements Action {
  readonly type = QUERY_SAP_INVOICES_START;
  logPayload = true;

  constructor(readonly payload: { filter: SapInvoiceFilter }) {}
}

export class QuerySapInvoicesSuccessAction implements Action {
  readonly type = QUERY_SAP_INVOICES_SUCCESS;

  constructor(readonly payload: { filter: SapInvoiceFilter; invoices: SapInvoicesFromMW; customers: Customer[] }) {}
}

export class QuerySapInvoicesFailAction implements Action {
  readonly type = QUERY_SAP_INVOICES_FAIL;
  logPayload = true;

  constructor(readonly payload: { errorMessage: ErrorMessage }) {}
}

export class SapInvoiceDownloadAction implements Action {
  readonly type = SAP_INVOICE_DOWNLOAD;
  logPayload = true;

  constructor(readonly payload: { invoice: SapInvoice }) {}
}

export class SapInvoiceDownloadSuccessAction implements BlobAction {
  readonly type = SAP_INVOICE_DOWNLOAD_SUCCESS;

  constructor(readonly payload: { blob: Blob; filename: string }) {}
}

export class SapInvoiceDownloadFailAction implements Action {
  readonly type = SAP_INVOICE_DOWNLOAD_FAIL;
  logPayload = true;

  constructor(readonly payload: Error) {}
}

export class SapInvoiceDownloadListAction implements Action {
  readonly type = SAP_INVOICE_DOWNLOAD_LIST;
}

export class SapInvoiceDownloadListSuccessAction implements BlobAction {
  readonly type = SAP_INVOICE_DOWNLOAD_LIST_SUCCESS;

  constructor(readonly payload: { blob: Blob; filename: string }) {}
}

export class SapInvoiceDownloadListFailAction implements Action {
  readonly type = SAP_INVOICE_DOWNLOAD_LIST_FAIL;
  logPayload = true;

  constructor(readonly payload: Error) {}
}

export class GetValutaForCustomersAction implements Action {
  readonly type = GET_VALUTA_FOR_CUSTOMERS;
  logPayload = true;

  constructor(readonly payload: string[]) {}
}

export class GetValutaForCustomersSuccessAction implements Action {
  readonly type = GET_VALUTA_FOR_CUSTOMERS_SUCCESS;
  logPayload = true;

  constructor(readonly payload: { valutas: string[] }) {}
}

export class GetValutaForCustomersFailAction implements Action {
  readonly type = GET_VALUTA_FOR_CUSTOMERS_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class SetDefaultValutaAction implements Action {
  readonly type = SET_DEFAULT_VALUTA;
}

export type Actions =
  | QuerySapInvoicesStartAction
  | QuerySapInvoicesSuccessAction
  | QuerySapInvoicesFailAction
  | ClearSapInvoicesFilterAction
  | SapInvoiceDownloadAction
  | SapInvoiceDownloadSuccessAction
  | SapInvoiceDownloadFailAction
  | SapInvoiceDownloadListAction
  | SapInvoiceDownloadListSuccessAction
  | SapInvoiceDownloadListFailAction
  | GetValutaForCustomersSuccessAction
  | GetValutaForCustomersFailAction
  | SetDefaultValutaAction;
